import "react-bootstrap-typeahead/css/Typeahead.css";
import { DeprecatedBadge } from "../../shared/MergeBadges";
import { Badge, Tooltip, Text } from "@merge-api/merge-javascript-shared";
import { Info } from "lucide-react";
import clsx from "clsx";

export interface FormFieldCommonProps {
  subtitle?: string | JSX.Element;
  title?: string;
  example?: string;
  valueType?: string;
  deprecated?: boolean;
  choices?: any;
  className?: string;
  onBlur?: () => void;
  relationModel?: string;
  titleChildren?: string | JSX.Element;
  dataTestID?: string;
  titleRightChildren?: JSX.Element;
}

interface Props extends FormFieldCommonProps {
  children: JSX.Element | (JSX.Element | false | undefined)[];
}

function FormField({
  children,
  dataTestID,
  example,
  subtitle,
  title,
  valueType,
  deprecated,
  choices,
  className,
  onBlur,
  titleChildren,
  titleRightChildren,
}: Props) {
  return (
    <div className="flex flex-col gap-y-1.5 mb-9" onBlur={onBlur}>
      <div
        className={clsx("flex flex-row items-center justify-between", className)}
        data-testid={dataTestID}
      >
        <div className="flex flex-row items-center gap-x-1.5">
          {title && (
            <Text variant="h6" className="mb-0">
              {title}
            </Text>
          )}
          {valueType && <Badge>{valueType}</Badge>}
          {deprecated && <DeprecatedBadge />}
          {titleChildren}
        </div>
        {titleRightChildren}
      </div>
      {subtitle && (
        <Text variant="sm" className="text-gray-40">
          {subtitle}
          {choices && (
            <Tooltip
              title={`If you are hard-coding a value, include one of the following: ${choices.map(
                (choice: string) => " " + choice
              )}`}
            >
              <Info size={12} className="ml-1.5 float-right text-gray-40" />
            </Tooltip>
          )}
        </Text>
      )}
      {example && (
        <Text variant="pre-title" className="text-gray-40">
          {example}
        </Text>
      )}
      {children}
    </div>
  );
}

export default FormField;
